import { Component, Injector, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { ApplicationConstant } from '../../../../application.constant';
import { swErrorMessage } from '../../../../shared/constant/customer-journey/error-message-constant';
import { Gender } from '../../../../shared/enum/gender.enum';
import { YesNo } from '../../../../shared/enum/yesNo.enum';
import { PersonType } from '../../../../shared/models/contract/person-type.model';
import { CommonService } from '../../../../shared/service/common.service';
import { Utils } from '../../../../shared/Utils/Utils';
import { BaseSWQuestion } from '../../../extended-class/base-ws-question';
import { DateOptionModel } from '../../../models/date-option.model';
import { LookUpResourceModel } from '../../../models/lookup-resource.model';
import { ValidDateOption } from '../../../models/valid-date-option.model';
import { SectionWiseValidationService } from '../../../service/section-wise-validation.service';

@Component({
  selector: '[policyHolderInfo]',
  templateUrl: './policy-holder-info.component.html'
})
export class PolicyHolderInfoComponent extends BaseSWQuestion implements OnInit {
  public question: LookUpResourceModel;
  public personType: PersonType;
  public dateOption: DateOptionModel = new DateOptionModel();
  public genderQuestion: LookUpResourceModel;
  public monthQuestion: LookUpResourceModel;
  public isSubmitted = false;
  public validDateOption: ValidDateOption;
  private minDate: Date;
  private maxDate: Date;
  private readonly dateFormat = 'dd/MM/yyyy';

  public get sWErrorMessage() {
    return swErrorMessage;
  }

  constructor(
    serviceInjector: Injector,
    private sectionWiseValidationService: SectionWiseValidationService,
    private commonService: CommonService
  ) {
    super(serviceInjector);
  }

  public ngOnInit() {
    this.validDateOption = new ValidDateOption();

    const currentDate = new Date();
    this.maxDate = new Date(currentDate);
    this.minDate = new Date(currentDate.setFullYear(currentDate.getFullYear() - 90));

    this.activatedRoute.queryParams.subscribe((param: any) => {
      this.question = JSON.parse(param['question']);
    });

    this.swProcessStateService.swContractType$.pipe(take(1)).subscribe((contractType) => {
      this.contractType = contractType;
      this.personType = contractType.policyHolder?.personType?.find((x) => x.number === 1) ?? new PersonType();
      this.dateOption = Utils.getDateOption(this.personType.birthDate);
      this.personType.dateOption = Utils.getDateOption(this.personType.birthDate);
    });

    this.mapQuestion();
  }

  public saveSectionAnswer() {
    this.isSubmitted = true;
    this.validDateOption = this.sectionWiseValidationService.getValidDateOption(this.dateOption, this.minDate, this.maxDate);
    if (this.isValid(this.validDateOption)) {
      const selectedPersonDateOfBirth = new Date(this.dateOption.year, this.dateOption.month - 1, this.dateOption.day ?? 1);
      const dateOfBirthStringFormatted = this.commonService.customDateFormat(selectedPersonDateOfBirth, this.dateFormat);
      const dateOfBirthFormatted = this.commonService.formatDate(dateOfBirthStringFormatted);
      this.personType.birthDate = dateOfBirthFormatted;

      if (!this.contractType.policyHolder?.personType.length) {
        this.contractType.policyHolder.personType = [];
        this.contractType.policyHolder.personType[0] = new PersonType();
        this.personType.number = 1;
        this.personType.insured = YesNo.Yes;
      }

      if (typeof this.personType.gender === 'string') {
        this.personType.gender = Number(this.personType.gender);
      }

      this.contractType.policyHolder.personType[0].birthAgeInYears = this.commonService.getAgeUsingDateOfBirth(dateOfBirthStringFormatted);
      this.addGTMAnswer(this.question.QuestionNumber, this.personType.gender + '-' + this.personType.birthAgeInYears);
      this.swProcessStateService.updateSwProcessModel(this.contractType);

      this.sectionWiseService.closeSwqModal(this.question);
    }
  }

  public numberOnly(evt: any) {
    return Utils.isNumber(evt);
  }

  public onDayKeyUp() {
    // only allow value between 1 to 31
    if (this.dateOption.day == null || this.dateOption.day === 0) {
      this.dateOption.day = null;
      return;
    }
    if (this.dateOption.day > 31) {
      this.dateOption.day = parseInt((this.dateOption.day + '').charAt(0));
    }
  }

  private isValid(validDateOption: ValidDateOption) {
    return this.personType.gender !== Gender.None && validDateOption.isValidDate && validDateOption.isValidDay && validDateOption.isValidMonth && validDateOption.isValidYear;
  }

  private mapQuestion() {
    this.genderQuestion = ApplicationConstant.lookupResourceDetails.find((x) => x.QuestionKey === 'Question_Gender_Health') ?? new LookUpResourceModel();
    this.monthQuestion = ApplicationConstant.lookupResourceDetails.find((x) => x.QuestionKey === 'Question_BirthDate_Health') ?? new LookUpResourceModel();
  }
}
